import { ButtonContentProps, ButtonStyleProps, MiddleCompartment } from './Button.styles';

export const ButtonCompartments = ({
  leftContent,
  children,
  rightContent,
  ...viewProps
}: ButtonContentProps & ButtonStyleProps) => (
  <>
    {leftContent && <div>{leftContent}</div>}
    <MiddleCompartment leftContent={leftContent} rightContent={rightContent} {...viewProps}>
      {children}
    </MiddleCompartment>
    {rightContent && <div>{rightContent}</div>}
  </>
);
